'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ContextHostUI2 = require('../Core/ContextHostUI');

var _ContextHostUI3 = _interopRequireDefault(_ContextHostUI2);

var _eventsTab = require('./eventsTab');

var UITabEvents = _interopRequireWildcard(_eventsTab);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The interface to the context supplied by the Deskpro UI Tab component hosting the app
 *
 * @class
 * @extends {ContextHostUI}
 */
var ContextHostUITab = function (_ContextHostUI) {
  (0, _inherits3.default)(ContextHostUITab, _ContextHostUI);

  /**
   * @param {AppEventEmitter} outgoingDispatcher
   * @param {String} locationId the id of the specific location within the UITab where the app is mounted
   * @param {String} tabId the id of this tab
   * @param {String} tabUrl the Deskpro URL of this tab
   * @param {...*} rest internal parameters
   */
  function ContextHostUITab(_ref) {
    var outgoingDispatcher = _ref.outgoingDispatcher,
        locationId = _ref.locationId,
        tabId = _ref.tabId,
        tabUrl = _ref.tabUrl,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['outgoingDispatcher', 'locationId', 'tabId', 'tabUrl']);
    (0, _classCallCheck3.default)(this, ContextHostUITab);
    return (0, _possibleConstructorReturn3.default)(this, (ContextHostUITab.__proto__ || (0, _getPrototypeOf2.default)(ContextHostUITab)).call(this, (0, _extends3.default)({
      outgoingDispatcher: outgoingDispatcher,
      locationId: locationId,
      tabId: tabId,
      tabUrl: tabUrl
    }, rest)));
  }

  /**
   * @public
   * @return {String}
   */


  (0, _createClass3.default)(ContextHostUITab, [{
    key: 'isTabActive',


    /**
     * Checks if this tab is active
     *
     * @public
     * @method
     * @async
     * @return {Promise.<boolean, Error>}
     */
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.props.outgoingDispatcher.emitAsync(UITabEvents.EVENT_TAB_STATUS, this.props.tabId).then(function (status) {
                  return status.active;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isTabActive() {
        return _ref2.apply(this, arguments);
      }

      return isTabActive;
    }()
  }, {
    key: 'activateTab',


    /**
     * Activates this tab, making it visible
     *
     * @public
     * @method
     * @async
     * @return {Promise}
     */
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.props.outgoingDispatcher.emitAsync(UITabEvents.EVENT_TAB_ACTIVATE, this.props.tabId));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function activateTab() {
        return _ref3.apply(this, arguments);
      }

      return activateTab;
    }()

    /**
     * Closes this tab
     *
     * @public
     * @method
     * @async
     * @return {Promise.<null, Error>}
     */

  }, {
    key: 'closeTab',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.props.outgoingDispatcher.emitAsync(UITabEvents.EVENT_TAB_CLOSE, this.props.tabId));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function closeTab() {
        return _ref4.apply(this, arguments);
      }

      return closeTab;
    }()
  }, {
    key: 'tabId',
    get: function get() {
      return this.props.tabId.toString();
    }

    /**
     * the Deskpro URL of this tab, useful if you want to link directly to this tab
     *
     * @public
     * @return {String}
     */

  }, {
    key: 'tabUrl',
    get: function get() {
      return this.props.tabUrl.toString();
    }
  }]);
  return ContextHostUITab;
}(_ContextHostUI3.default);

exports.default = ContextHostUITab;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/ContextHostUITab.js
// module id = 324
// module chunks = 0